//takes a route pattern and an parameter object and formats the pattern with the parameters.
//reuses the route formatting built in to angular-ui-router library, but exposes it as our own library for easy maintainability.
//it also allows you to write unit tests to discover how the $urlMatcherFactory works internally.
angular.module('aprima-legacy-common').factory('RouteFormatter', ['$urlMatcherFactory', '_', function ($urlMatcherFactory, _) {
    'use strict';
    var formatRoute = function (routePattern, params) {
        var route;

        params = !_.isUndefined(params) ? params : {};

        route = $urlMatcherFactory.compile(routePattern).format(params);

        return route;
    };

    var formatRelativeRoute = function formatRelativeRoute(routePattern, parentRoutePattern, params) {
        var route;

        params = !_.isUndefined(params) ? params : {};
        if(routePattern.indexOf(parentRoutePattern + '/') === 0)
            routePattern = routePattern.substring(parentRoutePattern.length);
        route = $urlMatcherFactory.compile(routePattern).format(params);

        return route;
    };

    return {
        formatRoute: formatRoute,
        formatRelativeRoute: formatRelativeRoute
    };
}]);
